<template src="./index.html"></template>

<script>
import last from 'lodash/last'
import { format, parseISO } from 'date-fns'

export default {
  name: 'codeGenerationExport',

  data() {
    return {
      statistics: null,
      statisticsLoading: false,
      exporting: false,
      noUnsyncedData: false,
      total: 0,
      listData: [],
      page: {
        pageSize: 20,
        currentPage: 0,
        totalPage: 0,
      },
      gridOptions: {
        context: { componentParent: this },
        getRowHeight: () => 52,
        getRowStyle: () => ({ cursor: 'default' }),
      },
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: '#',
          field: 'id',
          width: 80,
        },
        {
          headerName: '파일명',
          field: 'export_id',
          flex: 1,
          minWidth: 260,
          cellRenderer: (params) => {
            const val = params.value || '-'
            return `<span style="font-family:monospace;font-size:12px;">${val}</span>`
          },
        },
        {
          headerName: '바코드 수',
          field: 'record_count',
          width: 120,
          cellRenderer: (params) => {
            const val = params.value != null ? params.value : '-'
            return `<strong>${val}</strong>`
          },
        },
        {
          headerName: '내보낸 일시',
          field: 'created_at',
          width: 180,
          cellRenderer: (params) => {
            if (!params.value) return '-'
            try {
              return format(parseISO(params.value), 'yyyy-MM-dd HH:mm')
            } catch {
              return params.value
            }
          },
        },
        {
          headerName: '상태',
          field: 'status',
          width: 120,
          cellRenderer: () => {
            return `<span style="color:#28C76F;font-size:12px;font-weight:600;letter-spacing:0.3px;">동기화 완료</span>`
          },
        },
      ],
    }
  },

  computed: {
    barcodeUsagePct() {
      const b = this.statistics && this.statistics.barcode
      if (!b) return 0
      const total = b.used_codes + b.remaining_codes
      if (!total) return 0
      return Math.round((b.used_codes / total) * 100)
    },
    barcodeBarColor() {
      const pct = this.barcodeUsagePct
      if (pct >= 90) return '#EA5455'
      if (pct >= 70) return '#FF9F43'
      return '#28C76F'
    },
  },

  watch: {
    'page.currentPage'() {
      this.loadHistory()
    },
  },

  created() {
    this.loadStatistics()
    this.loadHistory()
  },

  methods: {
    loadStatistics() {
      this.statisticsLoading = true
      this.$store.dispatch('GET_BARCODE_PREFIX_STATISTICS')
        .then((result) => {
          const prefixes = (result.data && result.data.prefixes) || []
          const active = prefixes.find((p) => p.is_active) || null
          this.statistics = active
            ? { barcode: { active_prefix: active.prefix, used_codes: active.used_codes, remaining_codes: active.max_sequence - active.used_codes } }
            : { barcode: null }
        })
        .catch(() => {
          this.statistics = null
        })
        .finally(() => {
          this.statisticsLoading = false
        })
    },

    loadHistory() {
      const params = { page: this.page.currentPage, limit: this.page.pageSize }
      this.$store.dispatch('GET_CODE_GENERATION_EXPORTS', params)
        .then((result) => {
          const items = result.items || []
          this.listData = items
          this.total = result.total ?? items.length
          this.page.totalPage = Math.ceil(this.total / this.page.pageSize) || 1
        })
        .catch(() => {
          this.listData = []
          this.total = 0
        })
    },

    exportXlsx() {
      this.exporting = true
      this.noUnsyncedData = false
      this.$store.dispatch('POST_CODE_GENERATION_EXPORT')
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          const contentDisposition = res.headers['content-disposition']
          let fileName = `barcode_export_${Date.now()}.xlsx`
          if (contentDisposition) {
            const parts = contentDisposition.split('\'\'')
            if (parts.length > 1) {
              fileName = decodeURIComponent(last(parts))
            } else {
              const match = contentDisposition.match(/filename="?([^";\n]+)"?/)
              if (match) fileName = match[1]
            }
          }
          link.href = url
          link.setAttribute('download', fileName)
          link.style.cssText = 'display:none'
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
          this.loadHistory()
          this.loadStatistics()
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            this.noUnsyncedData = true
          }
        })
        .finally(() => {
          this.exporting = false
        })
    },
  },
}
</script>
